// extracted by mini-css-extract-plugin
export var cardHeader = "_ez-0";
export var reorderHandle = "_ez-3";
export var titleArea = "_ez-1";
export var titleAreaWithHandle = "_ez-2";